import { Chip } from "@mui/material";
import { alpha } from "@mui/material/styles";

const NAMED_HEX: Record<string, string> = {
	red: "#ff0000",
	green: "#008000",
	blue: "#0000ff",
	black: "#000000",
	white: "#ffffff",
};

const resolveColor = (color: string | null) => {
	const candidate =
		NAMED_HEX[(color ?? "").trim().toLowerCase()] ?? color?.trim();

	if (!candidate) return "#3d556f";

	return candidate;
};

export const surfaceDefectChipSx = (color: string | null) => {
	const tint = resolveColor(color);

	return {
		height: 22,
		borderRadius: "6px",
		fontWeight: 600,
		fontSize: "0.7rem",
		backgroundColor: alpha(tint, 0.16),
		color: tint,
		border: `1px solid ${alpha(tint, 0.4)}`,
		"& .MuiChip-label": { px: 0.85 },
		"& .MuiChip-deleteIcon": { color: tint, opacity: 0.7 },
	};
};

type Props = {
	name: string;
	color: string | null;
};

export const SurfaceDefectChip = ({ name, color }: Props) => (
	<Chip size="small" label={name} sx={surfaceDefectChipSx(color)} />
);
